<template>
  <div class="public_teacher_policy_interpretation">
    <div class="page_middle">
      <img src="../img/indonesian_native_teacher_classA/logo2.png" alt="" class="logo">
      <div class="class_num">Leadership B</div>
      <div class="list_content">
        <div class="meet_wrap" v-for="(v, i) in courseList" :key="i">
          <div class="meet_date">
            <div class="date">{{new Date(+v[0].start_time).Format('MM.DD')}}</div>
            <img src="../img/indonesian_native_teacher_classA/jia.png" alt="" class="arrow" @click="spreadMeet(i)">
          </div>
          <transition name="slide-fade">
            <div class="meet_con" v-show="meetShowMap[i].sonShow">
              <ul>
                <li v-for="(item, index) in v" :key="index">
                  <div class="time_ramge">{{new Date(+item.start_time).Format('hh:mm')}}~{{new Date(+item.end_time).Format('hh:mm')}}</div>
                  <div class="meet_message_con">
                    <div class="meet_message">
                      <div class="message_en">{{item.name_en}}</div>
                      <div class="message_cn">{{item.name}}</div>
                    </div>
                    <img src="../img/indonesian_native_teacher_classA/play.png" alt="" class="play" v-if="item.status == 3" @click="replayFun(item.video_id)">
                  </div>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
      <div class="footer">版权所有： © 中外语言交流合作中心</div>
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay">
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <ali-player
          v-if="isPlay"
          :useFlashPrism="false"
          :useH5Prism='true'
          :autoplay="true"
          :isLive="false"
          :rePlay="false"
          :showBuffer="true"
          showBarTime="5000"
          width="80%" 
          height="700px" 
          controlBarVisibility="always"
          :encryptType="1"
          :vid="vid"
          :playauth="auth.PlayAuth"></ali-player>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import aliPlayer from './aliplayer'

export default {
  components: {
    aliPlayer
  },
  data () {
    return {
      isLogin: false,
      flag: false,
      user: {
          username: '',
          email: ''
      },
      subject_info: {},
      courseList: [],
      subject_id: null,
      beforeTime: 30, // 提前可进入直播间时间
      afterTime: 30, // 延后关闭直播间时间
      isPlay: false,
      subject_alias: '',
      meetShowMap: [],
      auth: '',
      vid: ''
    }
  },
  mounted () {
    this.customCheckLogin()
    // winter_olympics indonesian_native_teacher_classD
    
    this.subject_alias = 'indonesian_native_teacher_classD'
    this.getSubjectInfo(this.subject_alias)
  },
  methods: {
    toLogin() {
      window.location.href =
      this.baseUrl +
      "user/api/login?" +
      "callback=" +
      encodeURIComponent(window.location.href);
    },
    customCheckLogin() {
      this.checkLogin().then(res => {
        if(res.data.success){
            this.isLogin = true
            this.user = res.data.data
        } else {
            this.isLogin = false
        }
      })
    },
    toLogOut() {
      this.$utils.get('/user/api/logout').then(res => {
        if(res.data.success) {
            this.isLogin = false
        }
      })
    },
    // 获取专题信息
    getSubjectInfo(alias) {
        this.$utils.get('/subject/subject/readbyalias', {
            alias
        }).then(res => {
            if(res.data.success) {
                this.subject_info = res.data.data
                this.getCourseInfo(this.subject_info.id)
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 获取课程列表
    getCourseInfo(id) {
        this.$utils.get('/subject/lesson/getlist', {
            subject_id: id,
            limit: 200
        }).then(res => {
            if(res.data.success) {
                var now = new Date().getTime()
                var endTime = now - this.afterTime * 60 * 1000;
                var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                res.data.data.list.forEach(e => {
                    e.isOrder = false
                    e.customStatus = 0
                    if (nowBeforeFiveMin > e.start_time) {
                        e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                    }
                    if (endTime > e.end_time) {
                        e.customStatus = 2
                    }
                    e.date = Number(new Date(e.start_time).Format('DD'))
                })
                this.courseList = res.data.data.list
                this.courseList = Object.values(this.courseList.reduce((res, item) => {
                  res[item.date] ? res[item.date].push(item) : res[item.date] = [item];
                  return res;
                }, {}))
                

                this.courseList.forEach((v, i) => {

                  if (this.courseList[0][0].start_time > new Date().getTime() && this.courseList[this.courseList.length - 1][0].end_time < new Date().getTime()) {
                    this.meetShowMap.push(
                      {
                        'sonShow': i == 0 ? true : false
                      }
                    )
                  } else {
                    this.meetShowMap.push(
                      {
                        
                        // 'sonShow': (v[0].start_time <= new Date().getTime() <= v[0].end_time) ? true : false
                        'sonShow': (new Date(+v[0].start_time).getDate() == new Date().getDate()) ? true : false
                      }
                    )
                  }
                })

            }
        }).catch((r) => {
            console.log(r)
        })
    },
    spreadMeet (index) {
      this.meetShowMap.forEach((v, i) => {
        if (index == i) this.$set(v, 'sonShow', !v.sonShow)
        else this.$set(v, 'sonShow', false)
      })
    },
    replayFun (vid) {
      console.log(vid)
      let param = {
        vid
      }
      this.vid = vid

      this.$utils.get('/subject/lesson/getvideoauth', param).then(res => {
        if (res.data.success == true) {
          // debugger
          this.auth = res.data.data
          // debugger
          console.log(this.vid, this.auth.PlayAuth)
          this.isPlay = true
          this.$forceUpdate()
        }
      })
    },
    closeVideo() {
      this.isPlay = false
    },
    hasScrollbar () {
      this.flag = document.getElementsByClassName('public_teacher_policy_interpretation')[0].clientHeight > document.body.clientHeight
    }
  }
}
</script>

<style scoped lang="scss">
.public_teacher_policy_interpretation {
  width: 100%;
  min-height: 100vh;
  background: url('../img/indonesian_native_teacher_classA/background.png') no-repeat top;
  background-color: #0f409c;
  .page_middle {
    width: 1200px;
    margin: auto;
    overflow: hidden;
    .user_center {
      overflow: hidden;
      .loginInfo {
        font-size: 18px;
        color: #ffd782;
        float: right;
        margin-top: 30px;
        span {
          cursor: pointer;
        }
      }
    }
    .logo {
      display: block;
      margin: auto;
      margin-top: 50px;
    }
    .class_num {
      width: 225px;
      height: 50px;
      background-color: #0a317c;
      border-radius: 25px;
      font-family: DIN-Bold;
      font-size: 30px;
      color: #ffffff;
      text-align: center;
      line-height: 45px;
      margin: auto;
      margin-top: 20px;
    }
    .list_content {
      margin-top: 30px;
      .meet_wrap {
        padding: 15px;
        padding-right: 0;
        // padding-bottom: 0px;
        padding-left: 50px;
        background-color: rgba(255,255,255,0.8);
        border-radius: 10px;
        margin-bottom: 10px;
        .meet_date {
          overflow: hidden;
          .date {
            font-family: Arial;
            font-weight: bold;
	          font-size: 30px;
            color: #355993;
            float: left;
            margin-top: 12px;
          }
          .arrow {
            float: right;
            margin-top: 3px;
            cursor: pointer;
            padding: 15px;
            padding-right: 30px;
          }
        }
        .meet_con {
          li {
            border-bottom: 1px solid #355993;
            margin-bottom: 30px;
            &:last-child {
              border: 0;
              margin-bottom: 0;
            }
            .time_ramge {
              font-family: ArialMT;
	            font-size: 22px;
              color: #355993;
              margin-top: 10px;
            }
            .meet_message_con {
              margin-top: 24px;
              overflow: hidden;
              .meet_message {
                float: left;
                width: calc(100% - 120px);
                .message_en {
                  font-family: ArialMT;
	                font-size: 30px;
                  color: #2c2c2c;
                  word-break: break-word;
                }
                .message_cn {
                  font-size: 18px;
                  color: #2c2c2c;
                  margin-top: 16px;
                  margin-bottom: 30px;
                }
              }
              .play {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .footer {
      font-size: 16px;
      color: #ffffff;
      margin-top: 40px;
      margin-bottom: 30px;
      text-align: center;
    }
  }


  
  #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
  }
  #videoPlayWrapper .closeVideo {
      position: absolute;
      right: 20px;
      top: 10px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
  }
  .videoContent {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .videoContainer {
      text-align: center;
      width: 100%;
  }
  .videoContainer video {
      width: 62%;
  }
  video::-internal-media-controls-download-button {
      display:none;
  }
  video::-webkit-media-controls-enclosure {
      overflow:hidden;
  }
  video::-webkit-media-controls-panel {
      width: calc(100% + 30px);
  }
}
</style>
